/* Task 4 — cart nudge behaviour.
   Adds the paired warranty for one cart line, then re-renders the cart.
   Delegated from document, so it survives the theme re-rendering the cart.

   Loaded as an asset from layout/theme.liquid: the theme swaps cart HTML via
   DOMParser (Cart.updateAllHtml -> swapInNewContent), which never executes
   inline scripts, so an inline script in the snippet would go dead whenever
   the cart starts empty.

   The add goes through the theme's own Cart element class (Blockshop
   theme.js) when available: Cart.addItems fetches /cart/add.js, updates the
   basket and header count, and re-renders every cart view through the same
   theme:cart:*:updateHtml events the theme itself uses — so nothing needs to
   rebind. The manual section swap below is only a fallback. */
(function () {
  if (window.__warrantyNudgeBound) { return; }
  window.__warrantyNudgeBound = true;

  var SECTIONS = ['cart-drawer', 'cart-desktop', 'cart-mobile'];

  function cartClass() {
    return (window.customElements && customElements.get('cart-element')) || null;
  }

  function swapSections(sections) {
    var swapped = 0;
    SECTIONS.forEach(function (id) {
      var html = sections && sections[id];
      if (!html) { return; }
      var target = document.querySelector('[data-section-id="' + id + '"]');
      if (!target) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-section-id="' + id + '"]');
      if (fresh) { target.replaceWith(fresh); swapped++; }
    });
    return swapped;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-warranty-nudge-add]');
    if (!button) { return; }

    var root = button.closest('[data-warranty-nudge]');
    if (!root || root.dataset.busy === 'true') { return; }

    event.preventDefault();
    event.stopPropagation();
    root.dataset.busy = 'true';
    button.disabled = true;

    var errorEl = root.querySelector('[data-warranty-nudge-error]');
    if (errorEl) { errorEl.hidden = true; }

    var quantity = parseInt(root.dataset.quantity, 10);
    if (isNaN(quantity) || quantity < 1) { quantity = 1; }

    var Cart = cartClass();
    var sections = (Cart && Cart.sections) || SECTIONS;

    var payload = {
      items: [{
        id: Number(root.dataset.variantId),
        quantity: quantity,
        properties: {
          _covers_sku: root.dataset.coversSku,
          _covers_variant: root.dataset.coversVariant,
          _covers_title: root.dataset.coversTitle,
          _term: '2yr'
        }
      }],
      sections: sections.join(',')
    };

    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    };

    var request = Cart && typeof Cart.addItems === 'function'
      ? Cart.addItems(options)
      : fetch('/cart/add.js', options)
          .then(function (res) {
            if (!res.ok) { throw new Error('add failed: ' + res.status); }
            return res.json();
          })
          .then(function (data) {
            if (swapSections(data.sections) === 0) { window.location.reload(); }
          });

    request.catch(function (err) {
      console.warn('[warranty-nudge]', err);
      root.dataset.busy = 'false';
      button.disabled = false;
      if (errorEl) { errorEl.hidden = false; }
    });
  }, true);
})();
